import { Component, OnInit, Input, OnDestroy, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { TreeNode } from '../../models';
import { ReplaySubject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { RealtimeDataService } from '../../realtime-data.service';

@Component({
  selector: 'app-metric-tree-item',
  templateUrl: './metric-tree-item.component.html',
  styleUrls: ['./metric-tree-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MetricTreeItemComponent implements OnInit, OnDestroy {
  @Input() node: TreeNode;
  @Output() metricActionTriggered = new EventEmitter<string>();
  readonly destroyed = new ReplaySubject(1);

  public value: string;
  public valDisplayType: string;

  private subscription: Subscription;
  timestamp: number;

  constructor(private readonly rtDataService: RealtimeDataService,
    private readonly dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.node.data && this.node.data.displayVal) {
      this.value = this.node.data.displayVal['value'];
      this.timestamp = this.node.data.timestamp as number;
      switch (this.node.data.displayVal['type'].toLowerCase()) {
        case 'boolean':
          this.valDisplayType = 'checkbox';
          break;
        case 'table':
          this.valDisplayType = 'table';
          break;
        default:
          this.valDisplayType = 'text';
          break;
      }
    }

    this.rtDataService.metricSubject(this.node.label).pipe(takeUntil(this.destroyed)).subscribe(d => {
      if (!d.value?.includes('numOfColumns')) {
        this.value = d.value;
      }

      this.timestamp = d.timestamp;
      this.node.children.forEach(child => {
        const childVal = d.metric_properties.find(p => p.name === child.label);
        if (childVal) {
          if (child.data) {
            child.data.displayVal['value'] = childVal.value;
          } else {
            child.data = {
              displayVal: {
                value: childVal.value,
                type: childVal.data_type
              }
            };
          }
        }
      });
    });
  }

  checkboxActionTriggered(event: string) {
    const message = `Trigger ${event} action`;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: message });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.metricActionTriggered.emit(event);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
    this.destroyed.next();
    this.destroyed.complete();
  }

}